// Card validation and formatting utilities

export const parseCardLine = (line) => {
  // Remove all whitespace
  const cleaned = line.replace(/\s+/g, '');
  
  // Try to extract card data with various separators
  const patterns = [
    /(\d{15,16})[\|\/:,;\s]+(\d{1,2})[\|\/:,;\s]+(\d{2,4})[\|\/:,;\s]+(\d{3,4})/, // Standard format
    /(\d{15,16})(\d{2})(\d{2,4})(\d{3,4})/ // No separators
  ];

  for (const pattern of patterns) {
    const match = cleaned.match(pattern);
    if (match) {
      const [, cc, mes, ano, cvv] = match;
      return {
        cc,
        mes: mes.padStart(2, '0'),
        ano: ano.length === 4 ? ano.substring(2) : ano.padStart(2, '0'),
        cvv
      };
    }
  }
  
  return null;
};

export const isCardExpired = (month, year) => {
  const now = new Date();
  const currentYear = now.getFullYear() % 100;
  const currentMonth = now.getMonth() + 1;
  
  const cardYear = parseInt(year);
  const cardMonth = parseInt(month);
  
  if (cardYear < currentYear) return true;
  if (cardYear === currentYear && cardMonth < currentMonth) return true;
  
  return false;
};

export const formatCard = (cardData) => {
  if (!cardData) return null;
  return `${cardData.cc}|${cardData.mes}|${cardData.ano}|${cardData.cvv}`;
};

export const parseAndCleanCards = (text) => {
  const lines = text.split('\n');
  const validCards = [];
  const errors = [];
  
  lines.forEach((line, index) => {
    if (!line.trim()) return;
    
    const cardData = parseCardLine(line);
    if (!cardData) {
      errors.push({ line: index + 1, text: line, error: 'Invalid format' });
      return;
    }
    
    // Check if expired
    if (isCardExpired(cardData.mes, cardData.ano)) {
      errors.push({ line: index + 1, text: line, error: 'Expired card' });
      return;
    }
    
    const formatted = formatCard(cardData);
    if (!validCards.includes(formatted)) {
      validCards.push(formatted);
    }
  });
  
  return { validCards, errors };
};
